/** Directive that marks content for projection into the center column of HxThreeColumnLayout. @directive */

import { Directive, input } from '@angular/core';

/** Marks content for center column projection via ng-content selector. Standalone with optional aria-label. */
@Directive({
  selector: '[hxThreeColumnCenter]',
  standalone: true,
  host: {
    '[attr.aria-label]': 'ariaLabel()',
  },
})
export class HxThreeColumnCenter {
  /** Optional ARIA label for center column (applied via host binding). */
  ariaLabel = input<string | undefined>();
}
